// removed by extract-text-webpack-plugin
module.exports = {"m":"(min-width: 48em)","ixt-blue":"#003B5C","ixt-blue-600":"#205779","ixt-blue-800":"#00304d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button.css
// module id = 511
// module chunks = 2